<section class="search-content">
  <ion-grid>
    <ion-row class="container">
      <ion-col size="12">
        <ion-card class="search-content__card">
          <ion-card-header class="search-content__card--header">
            <ion-card-title>Buscar</ion-card-title>
          </ion-card-header>
          <ion-card-content class="search-content__card--content">
            <form autocomplete="off" [formGroup]="searchForm" class="" (ngSubmit)="onSearch()">

              <ion-row class="form-row form-row__inputs">
                <ion-col size="12" sizeLg="6">
                  <app-input [formGroup]="searchForm" label="Tipo de contenido" formControlName="public" maxlength="30"
                    type="select" [required]="false" [options]="contentTypeList"
                    [defaultValueSelect]="defaultValueSelect" />
                </ion-col>
                <ion-col size="12" sizeLg="6">
                  <app-input [formGroup]="searchForm" label="Estado del contenido" formControlName="state"
                    maxlength="30" type="select" [required]="false" [options]="stateList"
                    [defaultValueSelect]="defaultValueSelect" />
                </ion-col>
              </ion-row>
              <ion-row class="form-row form-row__buttons">
                <ion-button class="form-button form-button--solid" spinnerClickButton="6000" fill="solid" size="small"
                  type="submit" [disabled]="buttonOn()">Buscar</ion-button></ion-row>
            </form>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</section>
<section class="results">
  <app-content [contenData]="contenData" [managView]="true" />
</section>